import React from "react";

const GraphDashboard = ({ fill }) => {
  const [isLarge, setIsLarge] = React.useState(window.innerWidth >= 1920);
  React.useEffect(() => {
    const handleResize = () => setIsLarge(window.innerWidth >= 1920);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const width = isLarge ? 36 : 34;
  const height = isLarge ? 36 : 34;

  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} rx="5" fill={fill} />
      <path
        d="M21.375 11.25C21.375 10.9516 21.4935 10.6655 21.7045 10.4545C21.9155 10.2435 22.2016 10.125 22.5 10.125H24.75C25.0484 10.125 25.3345 10.2435 25.5455 10.4545C25.7565 10.6655 25.875 10.9516 25.875 11.25V24.75H26.4375C26.5867 24.75 26.7298 24.8093 26.8352 24.9148C26.9407 25.0202 27 25.1633 27 25.3125C27 25.4617 26.9407 25.6048 26.8352 25.7102C26.7298 25.8157 26.5867 25.875 26.4375 25.875H9.5625C9.41332 25.875 9.27024 25.8157 9.16475 25.7102C9.05926 25.6048 9 25.4617 9 25.3125C9 25.1633 9.05926 25.0202 9.16475 24.9148C9.27024 24.8093 9.41332 24.75 9.5625 24.75H10.125V21.375C10.125 21.0766 10.2435 20.7905 10.4545 20.5795C10.6655 20.3685 10.9516 20.25 11.25 20.25H13.5C13.7984 20.25 14.0845 20.3685 14.2955 20.5795C14.5065 20.7905 14.625 21.0766 14.625 21.375V24.75H15.75V16.875C15.75 16.5766 15.8685 16.2905 16.0795 16.0795C16.2905 15.8685 16.5766 15.75 16.875 15.75H19.125C19.4234 15.75 19.7095 15.8685 19.9205 16.0795C20.1315 16.2905 20.25 16.5766 20.25 16.875V24.75H21.375V11.25ZM22.5 24.75H24.75V11.25H22.5V24.75ZM19.125 24.75V16.875H16.875V24.75H19.125ZM13.5 24.75V21.375H11.25V24.75H13.5Z"
        fill="#6C747A"
      />
    </svg>
  );
};
export default GraphDashboard;
